export default {"src":"/hedera/_next/static/media/binance.61914f85.svg","height":14,"width":12};